import React, { useEffect, useMemo, useState } from "react";
import { useDispatch, useSelector } from "react-redux";
import { useUpdateEffect } from "react-use";
import debounce from 'lodash.debounce';
import { Divider, Stack, Typography, Backdrop, Box, Paper, Modal, Fade } from "@mui/material";
import { styled } from "@mui/system";
import { UpdateOutlined } from "@mui/icons-material";
import { LoadingButton } from "@mui/lab";

import { selectAuth } from "redux/slices/authSlice";
import { changeInfo, selectInfo } from "redux/slices/appSlice";

import ModalErrorBoundary from "components/errorBoundary/modalErrorBoundary";


const ModalContent = styled(Paper)(() => ({
  position: "absolute",
  top: "50%",
  left: "50%",
  transform: "translate(-50%, -50%)",
  overflow: "auto",
})
);
const ModalHeader = styled(Box)(() => ({}));
const ModalBody = styled(Box)(() => ({}));
const ModalFooter = styled(Box)(() => ({}));

const VersionChangeModal = () => {

  const dispatch = useDispatch()

  const auth = useSelector(selectAuth)
  const authUsername = useMemo(() => auth?.user?.data?.username || null, [auth])

  const currentInfo = useSelector(selectInfo)
  const [apiInfo, setApiInfo] = useState({})
  const [loader, setLoader] = useState(false)

  const versionDifference = useMemo(() => !!(apiInfo?.version && currentInfo?.version !== apiInfo?.version), [currentInfo, apiInfo])

  const updateVersion = () => {
    dispatch(changeInfo(apiInfo))
    setLoader(true)
  }

  useUpdateEffect(() => {
    window.location.reload(false);
  }, [currentInfo?.version])

  const versionCheck = async () => {
    let url = `/static/api/info.json?${Date.now()}`
    const headers = new Headers([['Content-Type', 'application/json']])
    fetch(url, { headers })
      .then(res => res.json())
      .then(res => setApiInfo(res))
      .catch(error => console.log(error))
  }
  const debouncedInfoCheck = useMemo(() => debounce(versionCheck, 1000), []);

  useEffect(() => {
    debouncedInfoCheck()
    let interval = setInterval(debouncedInfoCheck, 60000)

    return () => {
      clearInterval(interval)
      debouncedInfoCheck.cancel()
    }
  }, [debouncedInfoCheck])


  return (
    <ModalErrorBoundary>
      <Modal
        open={versionDifference}
        closeAfterTransition
        BackdropComponent={Backdrop}
        BackdropProps={{
          timeout: 500,
          sx: {
            backdropFilter: 'blur(10px)'
          }
        }}
      >
        <Fade in={versionDifference}>
          <ModalContent
            component='form' sx={{
              width: { xs: '100%', sm: '90%' },
              minWidth: {},
              maxWidth: { sm: '550px' },
              height: { xs: '100%', sm: 'unset' },
              minHeight: {},
              maxHeight: { sm: '90vh' },
            }}>
            <ModalHeader sx={{ p: 2 }}>
              <Typography >Version update: {currentInfo?.version} - {apiInfo?.version}</Typography>
            </ModalHeader>

            <Divider />

            <ModalBody sx={{ p: 2 }}>
              <Typography>{authUsername ? `${authUsername}, please` : 'Please'} press update to continue</Typography>
            </ModalBody>

            <Divider />

            <ModalFooter sx={{ p: 2 }}>
              <Stack direction='row' justifyContent="flex-end" alignItems="stretch" spacing={2}>
                <LoadingButton
                  type='submit'
                  onClick={updateVersion}
                  endIcon={<UpdateOutlined />}
                  loading={loader}
                  loadingPosition="end"
                  variant="contained"
                  color="primary"
                  disabled={loader}
                >Update</LoadingButton>
              </Stack>
            </ModalFooter>

          </ModalContent>
        </Fade>
      </Modal >
    </ModalErrorBoundary>
  );
}

export default VersionChangeModal;